import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { User } from '../../../models/user.model';
import { AppService } from '../../../models/app.service.model';
import { Company } from '../../../models/company.model';

export interface DocumentPageProps {};

type ContexType = {
  asideMinimize: string,
  setAsideMinimize: Dispatch<SetStateAction<string>>,
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  userLoggedIn: User | null,
  appServiceForUser: AppService | null,
  companyForUser: Company | null
};

const DocumentPage: React.FunctionComponent<DocumentPageProps> = props => {
  const {asideMinimize, setAsideMinimize, setRoute, userLoggedIn, appServiceForUser, companyForUser} = UseOutletContext()

  return (
    <Outlet context={{asideMinimize, setAsideMinimize, setRoute, userLoggedIn, appServiceForUser, companyForUser}}></Outlet>
  );
}

export function UseOutletContextDocument() {
  return useOutletContext<ContexType>()
};

export default DocumentPage;
